import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import Vuex from "vuex";
import App from "./featured-video-carousel/App.vue";
import store from "./featured-video-carousel/store/index.js";

/**
 * Set the slide content
 * **/
function hydrateApp() {
  let featuredVideos = window.featuredVideos ? window.featuredVideos : {};

  store.commit("updateField", {
    path: "videos",
    value: featuredVideos,
  });

  store.commit("updateField", {
    path: "currentVideo",
    value: featuredVideos[0],
  });

  console.log(featuredVideos);
}

/**
 * Set up config
 * **/
function init() {
  hydrateApp();
  new Vue({
    el: "#featured-video-carousel-app",
    store,
    render: (h) => h(App),
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});
